// Mixins
import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';

// Services
import registerService from '@/app/services/main/register/register-service.js';

// Constants
import { GA } from '@/app/constants/ga-constants';
import { STATUS_CODES } from '@/app/constants/status-constants';

export default {
    name: 'SelectPreferredBreeds',
    mixins: [
        GoogleAnalyticsMixins,
        dateMixins,
        toastMessageMixins,
        inputTextMixins
    ],
    props: {},
    data() {
        return {
            theads: [
				{ name: 'Breeds', searchLabel: null, sortLabel: null, isDesc: false, hasSearch: true, style: null },
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, hasToggle: true, style: 'width: 15%;' }
			],
            isAPILoading: false,
			isAgreeTNC: false,
            selectedBreeds: [],
            headerToggleCheckbox: false,
            filter: ''
        }
    },
    computed: {
        breedLists() {
			return this.$store.getters.getBreedLists;
		},
        userDetails() {
            return this.$store.getters.getRegistrationUserDetails;
        },
		authStatus() {
			return this.$store.getters.getAuthMessage;
		},
        petDetails() {
            return this.$store.getters.getAddPetDetails;
        },
        isDisabled() {
            return !(this.selectedBreeds.length !== 0 && this.isAgreeTNC);
        },
        geoLocation() {
            return this.$store.getters.getGeoLocation;
        },
        displayBreeds() {
            if (this.filter.trim !== '') {
                return this.$store.getters.getBreedLists.filter(breed => { 
                    if (breed.name.toLowerCase().includes(this.filter.toLowerCase())) {
                        return  breed;
                    }
                });
            } else {
                return this.$store.getters.getBreedLists;
            }
        }
    },
    watch: {
        selectedBreeds(newVal) {
            if (newVal) {
                if (newVal.length !== this.breedLists.length) {
                    this.headerToggleCheckbox = false;
                } else {
                    this.headerToggleCheckbox = true;
                }
            }
        }
    },
    methods: {
		commitAuthStatus(status, message) {
			this.$store.commit('setAuthMessage', {status, message});
		},	
        setActiveComponent() {
			this.$emit('setActiveComponent', 'add-human-walker-sitter');
		},
        toggleSelectDeselect(event) {
            this.headerToggleCheckbox = event.target.checked;

            if (this.headerToggleCheckbox) {
                this.selectedBreeds = this.breedLists.map(breed => { return breed.id; });
            } else {
                this.selectedBreeds = [];
            }
        },
        toggleApplicableBreed (event, breedId) {

            if (event.target.checked) {
                this.selectedBreeds.push(breedId);
            } else {
                const i = this.selectedBreeds.indexOf(breedId);
                this.selectedBreeds.splice(i,1);
            }

        },
        onDoneRegistration() {
            if(this.isDisabled || this.isAPILoading) {
                return;
            }

            this.commitAuthStatus('', '');
			
			this.isAPILoading = true;

			let registerDetails = {
			    formDetails: {
			        userDetails: {
			            firstName: this.userDetails.userDetail.firstName,
			            lastName: this.userDetails.userDetail.lastName,
			            defaultTimezone: this.userDetails.userDetail.selectedTimeZone,
			            email: this.userDetails.userDetail.email,
                        address: this.userDetails.userDetail.address,
                        latitude: this.geoLocation.latitude,
                        longitude: this.geoLocation.longitude
                    },
                    walkerSitterDetails: {
                        biography: this.userDetails.userDetail.bio,
                        coverage: this.userDetails.userDetail.coverage,
                        breed: this.selectedBreeds,
                        role: this.petDetails.role
                    }
			    },
				userImage: this.userDetails.profileImageUpload[0]
			};

            if (this.petDetails.name && this.petDetails.breedId && this.petDetails.birthdate && this.petDetails.gender) {

                registerDetails.formDetails.petDetails = {
                    name: this.petDetails.name,
                    breedId: this.petDetails.breedId,
                    birthdate: this.dateToISO(this.petDetails.birthdate),
                    gender: this.petDetails.gender
                };

                registerDetails.petImg= this.petDetails.petImageUpload[0];
            }

			// lmdc register api
			registerService.postRegister(registerDetails)
			    .then(res => {
			        if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
			            this.isAPILoading = false;

			            // clear stored pet Details
			            this.$store.commit('clearAddPetDetails');

			            // Send Analytics
						this.sendEventTrackingToGA(GA.REGISTRATION_PAGE.CREATE_ACCOUNT_BUTTON.ACTION, GA.REGISTRATION_PAGE.CATEGORY, GA.REGISTRATION_PAGE.CREATE_ACCOUNT_BUTTON.LABEL);

			            this.$swal({
							imageHeight: '30px',
			                imageUrl: `${require('@/assets/images/_shared/success-dog.png')}`,
			                imageAlt: 'Success Dog',
			                title: 'Awesome!',
			                text: 'Please check your email for verification.',
			                confirmButtonColor: '#4B8BFF',
			                confirmButtonText: 'Got it'
			            }).then(() => {
			                this.$router.push('/login');
			            });
			        } else {
						this.isAPILoading = false;
			            this.commitAuthStatus('failed', res.data.errors);
			        }
			    });
        },
        filterBreed(event) {
            this.delayTyping(() => {
                this.filter = event.target.value;
            });
        }
    }
}